module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Honey_30.9daf732c.png";